import { render, staticRenderFns } from "./SectionCardImageIcon.vue?vue&type=template&id=2e8b8ee4&scoped=true&"
import script from "./SectionCardImageIcon.vue?vue&type=script&lang=ts&"
export * from "./SectionCardImageIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCardImageIcon.vue?vue&type=style&index=0&id=2e8b8ee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b8ee4",
  null
  
)

export default component.exports